import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import { ToastProvider } from './hooks/useToast';
import Dashboard from './pages/Dashboard';
import { DeviceAuthPage } from './pages/DeviceAuthPage';
import RepositoriesPage from './pages/RepositoriesPage';
import SchedulesPage from './pages/SchedulesPage';
import IntegrationsPage from './pages/IntegrationsPage';
import SettingsPage from './pages/SettingsPage';
import BillingPage from './pages/BillingPage';
import ApiDocsPage from './pages/ApiDocsPage';

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <Routes>
          <Route path="/auth/device" element={<DeviceAuthPage />} />
          <Route path="/" element={<Dashboard />}>
            <Route index element={<RepositoriesPage />} />
            <Route path="schedules" element={<SchedulesPage />} />
            <Route path="integrations" element={<IntegrationsPage />} />
            <Route path="billing" element={<BillingPage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="api-docs" element={<ApiDocsPage />} />
          </Route>
        </Routes>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
